import React, { ReactElement } from 'react'
import { Heading, Box, VStack } from '@chakra-ui/react'
import { Button } from '../Button'
import { CheckMark } from '../../icons'
import { useColor } from '../../theme'
import { IModal, useModal } from './Modal'

interface IConfirmationModalProps {
  title: string
  actionText: string
  description?: ReactElement
  onClick?: VoidFunction
  icon?: ReactElement
  actionSelector?: string
}

/**
 * @deprecated Please use the `Dialog` component instead
 */
export function useConfirmationModal({
  actionSelector,
  actionText,
  description,
  icon,
  onClick,
  title,
}: IConfirmationModalProps): Pick<
  IModal,
  'isOpen' | 'ModalComponent' | 'open'
> {
  const descriptionColor = useColor({ nuance: 0, palette: 'text' })
  const green = useColor({ nuance: 4, palette: 'green' })

  const defaultIcon = <CheckMark boxSize={10} color={green} />

  const { ModalComponent, open, close, isOpen } = useModal({
    body: <Box color={descriptionColor}>{description}</Box>,
    header: (
      <VStack align="left" spacing={4}>
        {icon ?? defaultIcon}
        <Heading as="h3">{title}</Heading>
      </VStack>
    ),
    footer: (
      <Button
        id={actionSelector}
        onClick={() => {
          onClick?.()
          close()
        }}
        size="lg"
        variant="secondary"
        width="full">
        {actionText}
      </Button>
    ),
  })

  return { open, ModalComponent, isOpen }
}
